import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { LANGUAGES } from "../i18n/languages";

const BASE = "https://www.lingomind.app";

const upsert = (selector, tag, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute("data-seo", "1");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const SeoHead = ({ page }) => {
  const { t, lang } = useLanguage();

  useEffect(() => {
    const seo = t.seo || {};
    const title = page === "help" ? seo.helpTitle : seo.homeTitle;
    const desc = page === "help" ? seo.helpDesc : seo.homeDesc;
    if (!title) return;

    const pathFor = (l) => (page === "help" ? `/${l}/help` : `/${l}`);
    const canonicalPath = page === "help" ? `/${lang}/help` : `/${lang}`;

    document.title = title;
    upsert('meta[name="description"]', "meta", { name: "description", content: desc });
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: `${BASE}${canonicalPath}` });
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: desc });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: `${BASE}${canonicalPath}` });
    upsert('meta[property="og:type"]', "meta", { property: "og:type", content: "website" });
    upsert('meta[property="og:image"]', "meta", { property: "og:image", content: `${BASE}/logo-full.png` });
    upsert('meta[name="twitter:card"]', "meta", { name: "twitter:card", content: "summary_large_image" });

    document.head.querySelectorAll('link[rel="alternate"][data-seo]').forEach((e) => e.remove());
    LANGUAGES.forEach((l) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.setAttribute("hreflang", l.code);
      link.setAttribute("href", `${BASE}${pathFor(l.code)}`);
      link.setAttribute("data-seo", "1");
      document.head.appendChild(link);
    });
    const xd = document.createElement("link");
    xd.rel = "alternate";
    xd.setAttribute("hreflang", "x-default");
    xd.setAttribute("href", `${BASE}${page === "help" ? "/help" : "/"}`);
    xd.setAttribute("data-seo", "1");
    document.head.appendChild(xd);
  }, [t, lang, page]);

  return null;
};

export default SeoHead;
